"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'decoder';
exports.ACTIVATE_STB_DEVICE = exports.namespace + "/ACTIVATE_STB_DEVICE";
exports.ACTIVATE_STB_DEVICE_ASYNC = exports.namespace + "/ACTIVATE_STB_DEVICE_ASYNC";
exports.SET_INITIATE_DEVICE_ACTIVATION = exports.namespace + "/SET_INITIATE_DEVICE_ACTIVATION";
//# sourceMappingURL=constants.js.map